
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-06-07 (1.0.0) (jhoward)
 *    - Copy from PanchoWillies_defaultSection.vue component to Chi_defaultSection.vue component.
 *
 *  2023-08-18 (1.0.1) (jhoward)
 *    - Add custom intro page CSS to <Chi_defaultSection>.
 *
 *  2023-08-28 (1.1.0) (jhoward)
 *    - Use <menu-version> in <Chi_defaultSection>.
 *
 *  2025-02-11 (1.2.0) (jhoward)
 *    - Add <menu-schedules> to the <Chi_defaultSection> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <Chi_defaultSection>.
 *    - Add textual and visual menu CSS tweaks to <Chi_defaultSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection,
    DefaultVisualSection,
  },
  name: "Chi_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
  computed: {
    containerClasses: function () {
      return {
        'menu--section-desserts': this.section.ms_title.toLowerCase() === 'desserts',
      };
    }
  },
})
